export const MOVE_ARROW_END = "MOVE_ARROW_END";
export const MOVE_ARROW_START = "MOVE_ARROW_START";
export const ADD_ARROW = "ADD_ARROW";
export const DELETE_ARROW = "ADD_ARROW";

export const CREATE_BLOCK = "CREATE_BLOCK";
export const DELETE_BLOCK = "DELETE_BLOCK";
export const MOVE_BLOCK = "MOVE_BLOCK";
export const UPDATE_DATA = "UPDATE_DATA";

export const START_CONNECT = "ENABLE_CONNECT";
export const FINISH_CONNECT = "FINISH_CONNECT";
export const SELECT_BLOCK = "SELECT_BLOCK";

export const INITIALIZE_OPTIONS = "INITIALIZE_OPTIONS";
export const UPDATE_ATTRIBUTE_VALUES = "UPDATE_ATTRIBUTE_VALUES";
export const UPDATE_ATTRIBUTE_SELECTION = "UPDATE_ATTRIBUTE_SELECTION";